import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { WorkzoneExact } from '../../../../../mission/models/Workzone';

const WorkzoneTreeView = ({ workzones, setWorkzones, setCenteredGeometries, disabled }) => {
  const handleWorkzonesCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(workzones, item.id));
    },
    [setCenteredGeometries, workzones]
  );

  const handleWorkzonesVisibilityClick = useCallback(
    (item, isToggled) => {
      setWorkzones((oldWorkzones) => getEntitiesWithVisibility(oldWorkzones, item.id, isToggled));
    },
    [setWorkzones]
  );

  const { current: workzoneItemActions } = useRef([
    { id: 'workzone-center', icons: { default: 'gps_fixed' }, onClick: handleWorkzonesCenterClick },
    {
      id: 'workzone-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleWorkzonesVisibilityClick,
    },
  ]);

  const workzoneItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('mission.details.workzones')}: ${workzones.length}`,
        actions: workzoneItemActions,
        disabled,
        children: workzones.map((workzone, index) => ({
          id: index,
          label: `${i18n.t('mission.details.workzone')} #${index + 1}`,
          actions: workzoneItemActions,
          disabled,
        })),
      },
    ],
    [disabled, workzoneItemActions, workzones]
  );

  return <TreeView id="workzones" items={workzoneItems} />;
};

WorkzoneTreeView.propTypes = {
  workzones: PropTypes.arrayOf(WorkzoneExact),
  setWorkzones: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

WorkzoneTreeView.defaultProps = {
  workzones: [],
  disabled: false,
};

export default WorkzoneTreeView;
